/*
 |--------------------------------------------------------------------------
 | UI / actions.js
 |--------------------------------------------------------------------------
 */

import * as mutation from './mutation_types'

export default {
    setIsMobile({ commit, getters }, data) {
        if (getters.isMobile !== data) commit(mutation.SET_IS_MOBILE, data)
    },
    setViewportHeight({ commit }, height) {
        commit(mutation.SET_VIEWPORT_HEIGHT, height)
    },
    setRecommendation({ commit }, recommendation) {
        commit(mutation.SET_RECOMMENDATION, recommendation)
        const modal = document.querySelector('.Overlay')
        recommendation ? (modal.style.width = '100%') : (modal.style.width = '0%')
    },
    setFeedback({ commit }, feedback) {
        commit(mutation.SET_FEEDBACK, feedback)
        const modal = document.querySelector('.Overlay')
        feedback ? (modal.style.width = '100%') : (modal.style.width = '0%')
    },
    setMap({ commit }, map) {
        commit(mutation.SET_MAP, map)
        const modal = document.querySelector('.Overlay')
        map ? (modal.style.width = '100%') : (modal.style.width = '0%')
    },
    setTranslation({ commit }, translation) {
        commit(mutation.SET_TRANSLATION, translation)
    },
    setCurrentLanguage({ commit }, language) {
        commit(mutation.SET_CURRENT_LANGUAGE, language)
    },
    setCurrentCoordinates({ commit }) {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(position => {
                const coords = {
                    lat: position.coords.latitude,
                    lng: position.coords.longitude
                }
                commit(mutation.SET_CURRENT_COORDINATES, coords)
            })
        }
    }
}
